<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>
  <div style="display: flex; gap: 20px; flex-direction: column;">

    <p style="margin: 0;">{{ data.message }}</p>
    
    <!-- Path Parameters Section -->
    <div class="params-section">
      <h3>Parámetros de Path</h3>
      <div class="params-list">
        <div *ngFor="let param of pathParamsList; let i = index; trackBy: trackByIndex" class="param-row">
          <mat-form-field color="accent" class="param-field-full">
            <mat-label>Valor</mat-label>
            <mat-icon matPrefix color="primary">link</mat-icon>
            <input matInput [(ngModel)]="pathParamsList[i]" placeholder="ej: 123, user-id-456">
          </mat-form-field>
          <div class="icon-btn">
          <button class="icon-button" mat-stroked-button  color="warn" (click)="removePathParam(i)">
            <mat-icon>delete</mat-icon>
          </button>
          </div>
        </div>
      </div>
      
      <button  style="width: 100%;"  mat-flat-button color="accent" type="button" (click)="addPathParam()" tabindex="-1">
        <mat-icon>add_circle</mat-icon>
        Añadir Parámetro de Path
      </button>
    </div>
    
    <!-- Query Parameters Section -->
    <div class="params-section">
      <h3>Parámetros de Query</h3>
      <div class="params-list">
        <div *ngFor="let param of queryParamsList; let i = index" class="param-row">
          <mat-form-field color="accent" class="param-field">
            <mat-label>Clave</mat-label>
            <mat-icon matPrefix color="primary">vpn_key</mat-icon>
            <input matInput [(ngModel)]="queryParamsList[i].key" placeholder="ej: filter, page">
          </mat-form-field>
          
          <mat-form-field color="accent" class="param-field">
            <mat-label>Valor</mat-label>
            <mat-icon matPrefix color="primary">input</mat-icon>
            <input matInput [(ngModel)]="queryParamsList[i].value" placeholder="ej: active, 1">
          </mat-form-field>
          <div class="icon-btn">
            <button class="icon-button" mat-stroked-button color="warn" (click)="removeQueryParam(i)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
      </div>
      
      <button style="width: 100%;" mat-flat-button color="accent" type="button" (click)="addQueryParam()" tabindex="-1">
        <mat-icon>add_circle</mat-icon>
        Añadir Parámetro de Query
      </button>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button color="warn" (click)="onCancel()" tabindex="-1">
    <mat-icon>cancel</mat-icon>
    Cancelar</button>
  <button mat-flat-button color="accent" (click)="onConfirm()" tabindex="-1">
    <mat-icon>check_circle</mat-icon>
    Confirmar</button>
</mat-dialog-actions>
